/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiLiveSessionReminderSendPost } from '../fn/live-session-reminder/api-live-session-reminder-send-post';
import { ApiLiveSessionReminderSendPost$Params } from '../fn/live-session-reminder/api-live-session-reminder-send-post';


/**
 * Live Session Reminder service
 */
@Injectable({ providedIn: 'root' })
export class LiveSessionReminderService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiLiveSessionReminderSendPost()` */
  static readonly ApiLiveSessionReminderSendPostPath = '/api/live_session_reminder/send';

  /**
   * Send reminders for upcoming live sessions.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLiveSessionReminderSendPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLiveSessionReminderSendPost$Response(params?: ApiLiveSessionReminderSendPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiLiveSessionReminderSendPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Send reminders for upcoming live sessions.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLiveSessionReminderSendPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLiveSessionReminderSendPost(params?: ApiLiveSessionReminderSendPost$Params, context?: HttpContext): Observable<void> {
    return this.apiLiveSessionReminderSendPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
